<template>
  <div class="fm-page">
    <div class="fm-card">
      <el-form :inline="true" :model="query" class="fm-query" @submit.native.prevent>
        <el-form-item label="围栏编码">
          <el-input v-model.trim="query.fenceCode" clearable placeholder="请输入围栏编码" @keyup.enter.native="search" />
        </el-form-item>
        <el-form-item label="围栏名称">
          <el-input v-model.trim="query.fenceName" clearable placeholder="请输入围栏名称" @keyup.enter.native="search" />
        </el-form-item>
        <el-form-item label="围栏类型">
          <el-select v-model="query.fenceType" clearable placeholder="全部" style="width: 130px">
            <el-option label="全部" value="" />
            <el-option label="圆形围栏" :value="1" />
            <el-option label="多边形围栏" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="事件类型">
          <el-select v-model="query.eventType" clearable placeholder="全部" style="width: 210px">
            <el-option label="全部" value="" />
            <el-option label="驶入" :value="1" />
            <el-option label="驶出" :value="2" />
            <el-option label="区域内停车" :value="3" />
            <el-option label="驶入+驶出" :value="4" />
            <el-option label="驶入+驶出+驶出超时" :value="5" />
            <el-option label="驶入+区域内停车" :value="6" />
            <el-option label="驶入+驶出+区域内停车" :value="7" />
            <el-option label="驶入+驶出+区域内停车+驶出超时" :value="8" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.status" clearable placeholder="全部" style="width: 110px" @change="search">
            <el-option label="全部" value="" />
            <el-option label="正常" :value="1" />
            <el-option label="禁用" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <div class="fm-toolbar">
        <div class="fm-toolbar__left">
          <el-button v-permission="'fence:add'" type="primary" icon="el-icon-plus" @click="openCreate">新增运单围栏</el-button>
        </div>
        <div class="fm-toolbar__tools">
          <el-tooltip content="刷新" placement="top"><el-button icon="el-icon-refresh" @click="fetchList" /></el-tooltip>
        </div>
      </div>

      <el-table v-loading="loading" :data="pageList" border stripe>
        <el-table-column prop="fenceCode" label="围栏编码" min-width="180" align="center" show-overflow-tooltip />
        <el-table-column prop="fenceName" label="围栏名称" min-width="160" align="center" show-overflow-tooltip />
        <el-table-column label="围栏类型" width="110" align="center">
          <template slot-scope="{ row }"><el-tag :type="Number(row.fenceType) === 1 ? 'info' : 'warning'" size="small">{{ fenceTypeText(row.fenceType) }}</el-tag></template>
        </el-table-column>
        <el-table-column label="事件类型" min-width="190" align="center" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ eventTypeText(row.eventType) }}</template>
        </el-table-column>
        <el-table-column label="围栏坐标" min-width="220" align="center" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ displayFenceCoords(row.fenceCoords) }}</template>
        </el-table-column>
        <el-table-column label="半径（米）" width="110" align="center">
          <template slot-scope="{ row }">{{ Number(row.fenceType) === 1 ? (row.fenceRadius || '-') : '-' }}</template>
        </el-table-column>
        <el-table-column label="状态" width="105" align="center">
          <template slot-scope="{ row }">
            <el-switch v-permission="'fence:edit'" :value="Number(row.status) === 1 && !Number(row.deleted) ? 1 : 2" :active-value="1" :inactive-value="2" active-color="#13ce66" inactive-color="#c0c4cc" @change="changeStatus(row, $event)" />
            <el-tag size="small" :type="Number(row.status) === 1 && !Number(row.deleted) ? 'success' : 'info'">{{ Number(row.status) === 1 && !Number(row.deleted) ? '正常' : '禁用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="170" align="center">
          <template slot-scope="{ row }">{{ row.createTime | fmt }}</template>
        </el-table-column>
        <el-table-column label="操作" width="235" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="onViewFence(row)">详情</el-button>
            <el-button v-permission="'fence:edit'" type="text" size="small" @click="openEdit(row)">编辑</el-button>
            <el-button v-permission="'fence:delete'" type="text" size="small" class="fm-delete" @click="removeFence(row)">删除</el-button>
            <el-button v-permission="'fence:delete'" type="text" size="small" @click="showReferences(row)">关联运单</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="fm-pagination">
        <el-pagination background :current-page="page" :page-size="limit" :page-sizes="[10, 20, 50]" :total="total" layout="total, sizes, prev, pager, next, jumper" @size-change="changePageSize" @current-change="changePage" />
      </div>
    </div>

    <waybill-fence-dialog :visible.sync="dialogVisible" :saving="submitting" :readonly="fenceReadonly" :fence="editingFence" @submit="onSubmitFence" />

    <el-dialog title="关联运单" :visible.sync="referencesVisible" width="680px" @close="closeReferences">
      <el-table v-loading="referencesLoading" :data="references" border>
        <el-table-column prop="waybillNo" label="运单号" min-width="200" />
        <el-table-column label="运输状态" width="140"><template slot-scope="{ row }">{{ referenceStatusText(row.transportStatus) }}</template></el-table-column>
        <el-table-column label="创建时间" width="180"><template slot-scope="{ row }">{{ row.createTime | fmt }}</template></el-table-column>
      </el-table>
      <el-pagination background layout="total, prev, pager, next" :current-page="referencesPage" :page-size="referencesLimit" :total="referencesTotal" @current-change="changeReferencesPage" />
      <span slot="footer"><el-button @click="referencesVisible = false">关闭</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { deleteFence, getFenceList, getFenceReferences, saveFence, updateFence, updateFenceStatus, isRequestSuccess } from './lingdongApi'
import { defaultBusinessOptions, businessOptionLabel } from '@/utils/businessDictionaries'
import { wgs84RouteToGcj02Text } from './coordinate'
import WaybillFenceDialog from './WaybillFenceDialog.vue'

const initialQuery = () => ({ fenceCode: '', fenceName: '', fenceType: '', eventType: '', status: 1 })

export default {
  name: 'FenceManage',
  components: { WaybillFenceDialog },
  filters: {
    fmt(value) { return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '-' }
  },
  data() {
    return {
      loading: false,
      requestId: 0,
      referencesVisible: false,
      referencesLoading: false,
      referencesRequestId: 0,
      references: [],
      referencesTotal: 0,
      referencesPage: 1,
      referencesLimit: 10,
      referenceFenceCode: '',
      list: [],
      total: 0,
      page: 1,
      limit: 10,
      query: initialQuery(),
      dialogVisible: false,
      editingFence: {},
      submitting: false,
      fenceReadonly: false
    }
  },
  computed: {
    pageList() {
      const start = (this.page - 1) * this.limit
      return this.list.slice(start, start + this.limit)
    }
  },
  created() { this.fetchList() },
  beforeDestroy() { this.requestId += 1; this.referencesRequestId += 1 },
  methods: {
    displayFenceCoords(value) { return wgs84RouteToGcj02Text(value) || '-' },
    async fetchList() {
      const requestId = ++this.requestId
      this.loading = true
      try {
        const params = {}
        if (this.query.fenceCode) params.fenceCode = this.query.fenceCode
        if (this.query.fenceName) params.fenceName = this.query.fenceName
        if (this.query.fenceType !== '') params.fenceType = this.query.fenceType
        if (this.query.eventType !== '') params.eventType = this.query.eventType
        if (this.query.status !== '') params.status = this.query.status
        const res = await getFenceList(params)
        if (requestId !== this.requestId) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '查询失败')
        this.list = (res.data || []).filter(item => {
          if (params.fenceCode && !String(item.fenceCode || '').includes(params.fenceCode)) return false
          if (params.fenceType !== undefined && Number(item.fenceType) !== Number(params.fenceType)) return false
          if (params.eventType !== undefined && Number(item.eventType) !== Number(params.eventType)) return false
          return true
        }).sort((a, b) => new Date(b.createTime || 0).getTime() - new Date(a.createTime || 0).getTime())
        this.total = this.list.length
        const maxPage = Math.max(1, Math.ceil(this.total / this.limit))
        if (this.page > maxPage) this.page = maxPage
      } catch (error) {
        if (requestId !== this.requestId) return
        this.list = []
        this.total = 0
        this.$message.error(error.msg || error.message || '网络错误')
      } finally {
        if (requestId === this.requestId) this.loading = false
      }
    },
    search() {
      this.page = 1
      this.fetchList()
    },
    reset() {
      this.query = initialQuery()
      this.page = 1
      this.fetchList()
    },
    changePageSize(size) {
      this.limit = size
      this.page = 1
    },
    changePage(page) { this.page = page },
    fenceTypeText(type) { return Number(type) === 1 ? '圆形围栏' : '多边形围栏' },
    eventTypeText(type) {
      const labels = {
        1: '驶入',
        2: '驶出',
        3: '区域内停车',
        4: '驶入+驶出',
        5: '驶入+驶出+驶出超时',
        6: '驶入+区域内停车',
        7: '驶入+驶出+区域内停车',
        8: '驶入+驶出+区域内停车+驶出超时'
      }
      return labels[Number(type)] || '-'
    },
    openCreate() {
      this.fenceReadonly = false
      this.editingFence = {}
      this.dialogVisible = true
    },
    openEdit(row) {
      this.fenceReadonly = false
      this.editingFence = { ...row }
      this.dialogVisible = true
    },
    async onSubmitFence(fence) {
      if (this.fenceReadonly) return
      this.submitting = true
      try {
        const res = this.editingFence && this.editingFence.fenceCode
          ? await updateFence(this.editingFence.fenceCode, fence)
          : await saveFence(fence)
        if (!isRequestSuccess(res)) throw new Error(res.msg || '保存失败')
        this.$message.success(this.editingFence && this.editingFence.fenceCode ? '运单围栏修改成功' : '运单围栏创建成功')
        this.dialogVisible = false
        this.editingFence = {}
        this.search()
      } catch (error) {
        this.$message.error(error.msg || error.message || '网络错误')
      } finally {
        this.submitting = false
      }
    },
    onViewFence(row) {
      this.fenceReadonly = true
      this.editingFence = { ...row }
      this.dialogVisible = true
    },
    changeStatus(row, status) {
      const action = Number(status) === 1 ? '启用' : '禁用'
      this.$confirm(`确认${action}围栏“${row.fenceName}”吗？`, '提示', { type: 'warning' }).then(async () => {
        const res = await updateFenceStatus(row.fenceCode, Number(status))
        if (!isRequestSuccess(res)) throw new Error(res.msg || `${action}失败`)
        this.$message.success(`围栏已${action}`)
        this.fetchList()
      }).catch(error => {
        if (error && error !== 'cancel' && error !== 'close') this.$message.error(error.msg || error.message || `${action}失败`)
      })
    },
    removeFence(row) {
      this.$confirm(`确认删除围栏“${row.fenceName}”吗？删除后不能再绑定到新运单。`, '提示', { type: 'warning' }).then(async () => {
        const res = await deleteFence(row.fenceCode)
        if (!isRequestSuccess(res)) throw new Error(res.msg || '删除失败')
        this.$message.success('围栏已删除')
        this.fetchList()
      }).catch(error => {
        if (error && error !== 'cancel' && error !== 'close') {
          const message = error.msg || error.message || '删除失败'
          this.$message.error(message)
          if (/关联|引用|运单/.test(message)) this.showReferences(row)
        }
      })
    },
    referenceStatusText(status) { return businessOptionLabel('waybill_status', defaultBusinessOptions('waybill_status'), status) },
    showReferences(row) {
      this.referenceFenceCode = row.fenceCode
      this.referencesPage = 1
      this.references = []
      this.referencesTotal = 0
      this.referencesVisible = true
      return this.fetchReferences()
    },
    closeReferences() { this.referencesRequestId += 1; this.referencesLoading = false },
    changeReferencesPage(page) { this.referencesPage = page; this.fetchReferences() },
    async fetchReferences() {
      const requestId = ++this.referencesRequestId
      this.referencesLoading = true
      try {
        const res = await getFenceReferences(this.referenceFenceCode, { page: this.referencesPage, limit: this.referencesLimit })
        if (requestId !== this.referencesRequestId) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '查询关联运单失败')
        this.references = (res.data && res.data.items) || []
        this.referencesTotal = Number(res.data && res.data.total) || 0
      } catch (error) {
        if (requestId !== this.referencesRequestId) return
        this.references = []
        this.referencesTotal = 0
        this.$message.error(error.msg || error.message || '查询关联运单失败')
      } finally {
        if (requestId === this.referencesRequestId) this.referencesLoading = false
      }
    }
  }
}
</script>

<style scoped>
.fm-page { width: 100%; height: 100%; overflow: auto; padding: 16px; box-sizing: border-box; background: #f0f2f5; }
.fm-card { min-height: 100%; padding: 16px; background: #fff; border-radius: 4px; box-sizing: border-box; }
.fm-query { margin-bottom: 4px; }
.fm-toolbar { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.fm-pagination { display: flex; justify-content: flex-end; margin-top: 12px; }
.fm-delete { color: #e64545; }
</style>
